module.exports = __webpack_public_path__ + "media/images/faq/infl1-42bd4d71d29da1134a25c86e4a871645.png";